<template>
    <div class="vstack justify-content-start gap-3 p-3 px-4 flex-grow-1">
         <p class="text-center mb-0 py-2" style="font-size: 16px; color: #3B3A3A;">Tambahkan nama anda untuk menjadikan kad Raya ini lebih istimewa.</p>
        <!-- <button @click="designStore.seeCanvas"> canvas</button> -->
        <button class="btn btn-tnb-gradient w-100"  @click="continueHandler">Selesai dan Previu <Eye :size="16" class="ms-1" /></button>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { fabric } from "fabric";
import { storeToRefs } from 'pinia';
import useFabricCanvas from '../../composables/use-fabric-canvas';
import { useDesignStore } from '../../stores';
import { Eye } from 'lucide-vue-next';

const emits = defineEmits(['next']);

const [canvas] = useFabricCanvas();
const designStore = useDesignStore();
const { selectedTheme } = storeToRefs(designStore);

const defaultTextboxValue = 'Taip nama di sini';
let coords = {
    x: 0,
    y: 0
};

const MAX_TEXT_PX = designStore.postCardDimensionSettings.width * (
    selectedTheme.value === 2 ? 0.55 :
    selectedTheme.value === 3 ? 0.35 :
    0.60
);

const measureTextWidth = (text: string, fontSize: number, fontWeight: string, fontFamily: string): number => {
    const measureCanvas = document.createElement('canvas');
    const ctx = measureCanvas.getContext('2d')!;
    ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
    return ctx.measureText(text).width;
};

const addTextbox = () => {

    let nameTextBox = new fabric.Textbox(defaultTextboxValue, {
        name: 'textbox-element',
        width: designStore.postCardDimensionSettings.width * 0.75,
        fontSize: 16,
        fontFamily: 'Open Sans',
        fontWeight: 700,
        fill: '#A47020',
        top: (selectedTheme.value === 3 ? 97 : 88) * designStore.postCardDimensionSettings.height / 125,
        left: (designStore.postCardDimensionSettings.width / 2),
        textAlign: 'center',
        originX: 'center',
        lockMovementX: true,
        lockMovementY: true,
        hasControls: false,
        hasBorders: false,
        splitByGrapheme: false,
    });

    nameTextBox.set('fill', new fabric.Gradient({
        type: 'linear',
        gradientUnits: 'percentage',
        coords: { x1: 0, y1: 0, x2: 0, y2: 1 },
        colorStops: [
            { offset: 0, color: '#A47020' },
            { offset: 1, color: '#DDB56D' },
        ]
    }));

    // nameTextBox.on('changed', function () {
    //     if (!nameTextBox.text) return;
        
    //     const MAX_LENGTH = 25; 
        
    //     if (nameTextBox.text.length > MAX_LENGTH) {
    //         nameTextBox.text = nameTextBox.text.substring(0, MAX_LENGTH);
    //         nameTextBox.selectionStart = MAX_LENGTH;
    //         nameTextBox.selectionEnd = MAX_LENGTH;
    //         nameTextBox.dirty = true;
    //         canvas.renderAll();
    //     }
    // });

    nameTextBox.on('mousedown', function (obj) {
        coords = canvas.getPointer(obj.e);
    });

    nameTextBox.on('changed', function () {
        const obj = canvas.getActiveObject() as fabric.Textbox;
        if (!obj || !obj.hiddenTextarea || !obj.text) return;

        const fontSize = (obj.fontSize as number) ?? 16;
        const fontWeight = String(obj.fontWeight ?? 700);
        const fontFamily = String(obj.fontFamily ?? 'Open Sans');

        let currentText = obj.text.replace(/\n/g, '');
        while (currentText.length > 0) {
            const longestLine = currentText.split('\n').reduce((a, b) =>
                measureTextWidth(a, fontSize, fontWeight, fontFamily) >= measureTextWidth(b, fontSize, fontWeight, fontFamily) ? a : b
            );
            if (measureTextWidth(longestLine, fontSize, fontWeight, fontFamily) <= MAX_TEXT_PX) break;
            currentText = currentText.slice(0, -1);
        }

        if (currentText !== obj.text) {
            obj.text = currentText;
            obj.hiddenTextarea.value = currentText;
            obj.selectionStart = currentText.length;
            obj.selectionEnd = currentText.length;
            obj.dirty = true;
            canvas.renderAll();
        }
    });

    nameTextBox.on('mouseup', function (obj) {
        let e = canvas.getPointer(obj.e) as fabric.Point;
        if (e.x == coords.x && e.y == coords.y) {
            const objTarget = obj.target as fabric.IText;
            objTarget.enterEditing();
            // @ts-ignore
            objTarget.setCursorByClick(e);
        }
    });

    nameTextBox.on("editing:entered", function (e) {
        var obj = canvas.getActiveObject() as fabric.IText;
        if (obj.text === defaultTextboxValue) {
            obj.selectAll();
            obj.text = "";
            obj.hiddenTextarea!.value = "";
            obj.dirty = true;
            obj.setCoords();
            canvas.renderAll();
        }
    });

    nameTextBox.on("editing:exited", function (e) {
        var obj = nameTextBox;
        if (!obj) return;
        if (obj.text === '') {
            obj.text = defaultTextboxValue;
            obj.dirty = true;
            obj.setCoords();
            canvas.renderAll();
        }
    });

    canvas.add(nameTextBox);
}

const continueHandler = () => {
    const toRemove = canvas.getObjects().filter(item =>
        item && (item as any).name === 'textbox-element' &&
        item instanceof fabric.Textbox &&
        (item as fabric.Textbox).text === defaultTextboxValue
    );
    toRemove.forEach(item => canvas.remove(item));

    canvas.discardActiveObject();
    canvas.renderAll();
    emits('next');
}

onMounted(() => {
    const existing = canvas._objects.find(item => (item as any).name === 'textbox-element');
    if (!existing) {
        addTextbox();
    }
})

</script>

<style lang="scss" scoped>
</style>